/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import type { Theme } from '@mui/material';
import logger from '@utils/logger';

import { Brand, Brands } from '@/lib/constants';

// Only bundle the theme associated to our brand.
// We need to use a plain string comparision, otherwise all our themes
// would automatically be added to our app bundle.
let theme: Theme;
const brandFromEnv = Brand;

switch (brandFromEnv) {
  case Brands.BOSTON:
    theme = require('./boston').default;
    break;
  case Brands.MAYORAL:
    theme = require('./mayoral').default;
    break;
  case Brands.HUGANDCLAU:
    theme = require('./hugandclau').default;
    break;
  case Brands.ABELANDLULA:
    theme = require('./abelandlula').default;
    break;
  default:
    logger.warn(
      `Brand "${brandFromEnv}" is not supported. Please use one of the following brands: ${Object.values(
        Brands,
      ).join(', ')}.`,
    );
    theme = require('./mayoral').default;
}

export default theme;
